import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

// Отправить запрос на добавление актива (монета или RU-акция) в портфель
export async function addAssetToBriefcase({ coinId, stockRuId } = {}) {
  const url = `${backendUrl}/api/widgets/user-assets/`;
  const formData = new FormData();
  if (coinId) formData.append('coin_id', coinId);
  if (stockRuId) formData.append('stock_ru_id', stockRuId);

  try {
    const response = await fetchWithAuth(url, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при добавлении актива');
    }

    return await response.json();
  } catch (error) {
    console.error('API addAssetToBriefcase error:', error);
    throw error;
  }
}
